export default __webpack_public_path__ + "static/media/principles_focus.e318c4a7.png";